<template>
    <div id="contendor-principal-asigancion-SINOJ" class="container-fluid">
        <!-- SECCION DE ENCABEZADOS -->
        <div id="encabezados">
            <h1>ASIGNACIÓN DE CÉDULAS A NOTIFICADORES</h1>
            <h4>Consulta, asigna o reasigna las cédula a los notificadores</h4>
            <div class="hr-titulo"></div>
        </div>
        <!-- SECCIONES ASIGNACION -->
        <div id="secciones-asignacion" class="pt-4">
            <div class="card">
                <div class="card-header">
                    <h5>Recepcion de notificaciones</h5>
                </div>
                <div class="card-body">
                    <h5 class="card-title">Filtros de busqueda</h5>
                    <div class="row no-gutters filtros">
                        <!-- FILTRO DE JUZGADO -->
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-1 pt-1 mt-3">
                            <div class="form-group d-flex align-items-center">
                                <h6>Asignar por notificador:</h6>&nbsp;&nbsp;
                                <i style="cursor: pointer;" @click="evtAsignarPorNotificador" :class="[(ASIGNAR_POR_NOTIFICADOR.activo) ? 'fas fa-check-square' : 'far fa-square']"></i>
                            </div>
                        </div>
                        <!-- CATALOGO NOTIFICADOR -->
                        <div v-if="ASIGNAR_POR_NOTIFICADOR.activo" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pr-4 pt-1 mt-3">
                            <div class="form-group d-flex align-items-center">
                                <C020Notificadores v-if="ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.lista != null && ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.lista.length > 0"
                                    class="p-0 m-0" 
                                    v-on:valorParaElPadre="evtCambioNotificadorAsigancionPorNotificador" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.ID" 
                                    :listaDeNotificadores="ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.lista"
                                    :parametros="{}" 
                                    :valorDefinido="ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.valorDefinido" 
                                    :key="ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.KEY + ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.contRender"
                                    :filtrarPorJurisdiccion="true"></C020Notificadores>
                                <button type="button" @click="iniciarProcesoBusquedaDeCedulas({ busquedaPorNotificador: true })" class="ml-4 btn btn-sm btn-primary"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                            </div>
                        </div>
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-4 pt-1 mt-3" v-if="this.tablaAsignaciones.listaParaTabla.length > 0 && ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.mostrarModalReporteGeneralDeAsignaciones">
                            
                            <div class="form-group d-flex align-items-center">
                                <button type="button" @click="downloadReportAsignacionesNotificador({ conLoading: true })" class="btn-sm btn btn-danger"><i class="fas fa-file-pdf"></i>&nbsp;&nbsp;Descargar listado</button>
                            </div>
                        </div>
                    </div>
                    <hr v-if="ASIGNAR_POR_NOTIFICADOR.activo" style="height:1.4px;border:none;color:#FFF;background-color:rgb(51, 51, 51); margin-top:9px; margin-bottom:2em;"/>
                    <!-- FILTROS -->
                    <div :class="[(!ASIGNAR_POR_NOTIFICADOR.activo) ? 'row no-gutters filtros' : 'row no-gutters filtros seccion-deshabilitada']">
                        <!-- FILTRO DE JUZGADO -->
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-4 pt-1 mt-3">
                            <div class="form-group">
                                <h6>Juzgado</h6>
                                <C001Area 
                                    class="p-0 m-0" 
                                    v-on:valorParaElPadre="evtCambioDeJuzgado" 
                                    :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                    :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                    :idDelInput="filtros.catalogoJuzgado.ID" 
                                    :parametros="filtros.catalogoJuzgado.parametros" 
                                    :valorDefinido="filtros.catalogoJuzgado.valorDefinido" 
                                    :key="filtros.catalogoJuzgado.KEY + filtros.catalogoJuzgado.contRender"></C001Area>
                            </div>
                        </div>
                        <!-- FILTRO NUMERO DE EXPEDIENTE -->
                        <div id="f-expediente" class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-2 pt-1 mt-3">
                            <h6>Expediente</h6>
                            <div class="input-group">
                                <div class="input-group-append">
                                    <div class="input-group-text"><i class="fa fa-folder"></i></div>
                                </div>
                                <input class="form-control input-sm input-xs input-md input-lg py-2 border-left-0 border" type="text" v-model="filtros.numeroExpediente" v-mask="'####/####'" placeholder="####/####">
                            </div>
                        </div>
                        <!-- FILTRO FECHA INICIAL -->
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-2 pt-1 mt-3">
                            <div class="form-group">
                                <h6 class="mr-2">Fecha inicial</h6>
                                <input type="date" id="fechaInicial" v-model="filtros.fechaInicial" class="form-control" />
                            </div>
                        </div>
                        <!-- FILTRO FECHA FINAL -->
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-2 pt-1 mt-3">
                            <div class="form-group">
                                <h6 class="mr-2">Fecha final</h6>
                                <input type="date" id="fechaFinal" v-model="filtros.fechaFinal" class="form-control" />
                            </div>
                        </div>
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-3 pt-1 mt-3 align-self-end d-flex justify-content-end">
                            <div class="form-group">
                                <button type="button" class="btn btn-primary" @click="iniciarProcesoBusquedaDeCedulas({ busquedaPorNotificador: false })"><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
                            </div>
                        </div>
                        <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 pr-3 pt-1 mt-3 align-self-end d-flex justify-content-start">
                            <div class="form-group">
                                <button id="btn-reporte-asignaciones-notificadores" @click="mostrarModalReporteGeneralDeAsignaciones" type="button" class="btn-sm btn btn-light"><i class="fas fa-chart-bar"></i>&nbsp;&nbsp;Crear reporte</button>
                            </div>
                        </div>
                    </div>
                    <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(51, 51, 51); margin-top:9px; margin-bottom:2em;"/>
                    <!-- TABLA ASIGNACIONES -->
                    <div class="contenedor-tabla-asignacionesV2-SINOJ table-responsive" >
                        <!-- <div v-if="mostrarAcciones" class="d-flex">
                            <button type="button" class="btn btn-sm btn-danger mr-2" @click="evtMostrarModalReasignacion({ esMultiple: true, esParaRemover: true })"><i class="fas fa-user-minus"></i>&nbsp;&nbsp;Remover asignaciones</button>
                            <button type="button" class="btn bt-sm btn-light" @click="evtMostrarModalReasignacion({ esMultiple: true })"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Reasignar</button>
                        </div> -->
                        <div id="toolbar-tabla-asignaciones">
                            <div class="form-inline flex-wrap mt-2" style="gap: 2em !important;">
                                <div v-if="mostrarAcciones" class="d-flex">
                                    <button type="button" class="btn btn-sm btn-danger mr-2" @click="evtMostrarModalReasignacion({ esMultiple: true, esParaRemover: true })"><i class="fas fa-user-minus"></i>&nbsp;&nbsp;Remover asignaciones</button>
                                    <button type="button" class="btn bt-sm btn-light mr-2" @click="evtMostrarModalReasignacion({ esMultiple: true })"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Reasignar</button>
                                    <h6 class="mt-1"><strong>#Seleccionadas: {{ getNUmeroCedulasSeleccionadas }}</strong></h6>
                                </div>
                            </div>
                        </div>
                        <table
                            class="table table-light table-hover"
                            :id="tablaAsignaciones.ID"              
                            data-toggle="table"
                            data-pagination="true"
                            data-toolbar="#toolbar-tabla-asignaciones" 
                            data-toolbar-align="left"
                            data-undefined-text="Sin información"
                            data-maintain-selected="true"  
                            data-page-size = "5"
                            data-page-list="[3,5,10,20]"
                            data-click-to-select="false"
                            data-show-toggle="false"
                            data-show-pagination-switch="true"
                            data-search="true">
                            <thead class="thead-dark">
                                <tr>
                                    <th name="checkColumn" id="c-principal" data-halign="center" data-width="5" data-align="center" data-checkbox="true"></th>
                                    <th data-halign="center" data-width="5" data-align="center" data-field="CedulaId" data-sortable="true">
                                        Folio
                                    </th>
                                    <th data-halign="center" data-width="10" data-align="center" data-field="Expediente.Juzgado.Nombre" data-sortable="true">
                                        Juzgado
                                    </th>
                                    <th data-halign="center" data-width="10" data-align="center" data-field="NotificadorSTR" data-sortable="true">
                                        Notificador
                                    </th>
                                    <th data-halign="center" data-width="10" data-align="center" data-field="Expediente.TipoDocumento.Nombre" data-sortable="true">
                                        Tipo de documento
                                    </th>
                                    <th data-halign="center" data-width="6" data-align="center" data-field="Expediente.NumeroDeDocumento" data-sortable="true">
                                        Consecutivo
                                    </th>
                                    <th data-halign="center" data-width="10" data-align="center" data-field="TipoCedula.Nombre" data-sortable="true">
                                        Tipo de cedula
                                    </th>
                                    <th data-halign="center" data-width="15" data-align="center" data-field="DomicilioSTR" data-sortable="true">
                                        Domicilio
                                    </th>
                                    <th data-halign="center" data-width="15" data-align="center" data-field="PersonaANotificarSTR" data-sortable="true">
                                        Persona a notificar
                                    </th>
                                    <th data-halign="center" data-width="9" data-align="center" data-field="fechaRecepcionSTR" data-sortable="true">
                                        Fecha de recepcion
                                    </th>
                                    <th data-events="operateEvents" data-width="5" :data-formatter="this.obtenerHTMLAcciones()" data-halign="center" data-align="center">
                                        
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <!-- DATOS DE CEDULA -->
                    <div id="info-cedula" v-if="mostrarInformacionDeCedula">
                        <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(51, 51, 51); margin-top:9px; margin-bottom:2em;"/>
                        <div class="card">
                            <div class="card-header text-center">
                                <h4>Detalles cedula folio [#{{ this.cedulaSeleccionada.CedulaId }}]</h4>
                            </div>
                            <div class="card-body">
                                <div class="row no-gutters filtros">
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1 mt-3">
                                        <div class="d-flex align-items-center alert alert-dark" role="alert">
                                            <h6 class="mr-2 titulo-descripcion"><i class="fas fa-user"></i>&nbsp;&nbsp;Se notifica a:</h6><h6>{{ this.cedulaSeleccionada.PersonaANotificarSTR }}</h6>
                                        </div>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                        <div class="d-flex align-items-center alert alert-dark" role="alert">
                                            <h6 class="mr-2 titulo-descripcion"><i class="fas fa-id-card"></i>&nbsp;&nbsp;Numero de folio:</h6><h6>{{ this.cedulaSeleccionada.CedulaId }}</h6>
                                        </div>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                        <div class="d-flex align-items-center alert alert-dark" role="alert">
                                            <h6 class="mr-2 titulo-descripcion"><i class="fas fa-folder"></i>&nbsp;&nbsp;Documento:</h6><h6>{{ this.cedulaSeleccionada.Expediente.NumeroDeDocumento }}</h6>
                                        </div>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                        <div class="d-flex align-items-center alert alert-dark" role="alert">
                                            <h6 class="mr-2 titulo-descripcion"><i class="fas fa-file"></i>&nbsp;&nbsp;Tipo de notificacion:</h6><h6>{{ this.cedulaSeleccionada.TipoCedula.Nombre }}</h6>
                                        </div>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                        <div class="d-flex align-items-center alert alert-dark" role="alert">
                                            <h6 class="mr-2 titulo-descripcion"><i class="fas fa-calendar-alt"></i>&nbsp;&nbsp;Fecha de generacion:</h6><h6>{{ this.cedulaSeleccionada.fechaCreacionSTR }}</h6>
                                        </div>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                        <div class="d-flex align-items-center alert alert-dark" role="alert">
                                            <h6 class="mr-2 titulo-descripcion"><i class="fas fa-calendar-alt"></i>&nbsp;&nbsp;Fecha de proxima audiencia:</h6><h6>{{ this.cedulaSeleccionada.fehaAudienciaSTR }}</h6>
                                        </div>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                        <div class="d-flex align-items-center alert alert-dark" role="alert">
                                            <h6 class="mr-2 titulo-descripcion"><i class="fas fa-calendar-alt"></i>&nbsp;&nbsp;Fecha de auto:</h6><h6>{{ this.cedulaSeleccionada.fehaAutoSTR }}</h6>
                                        </div>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                        <div class="alert alert-dark" role="alert">
                                            <h6 class="mr-2 titulo-descripcion"><i class="fas fa-map-marked-alt"></i>&nbsp;&nbsp;Domicilio:</h6>
                                            <h6>{{ this.cedulaSeleccionada.DomicilioSTR }}</h6>
                                        </div>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-4 pt-1 mt-3">
                                        <div class="d-flex align-items-center alert alert-dark" role="alert">
                                            <h6 class="mr-2 titulo-descripcion"><i class="fas fa-running"></i>&nbsp;&nbsp;Notificador:</h6><h6>{{ this.cedulaSeleccionada.NotificadorSTR }}</h6>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-4 pt-1 mt-3">
                                        <hr style="height:1.4px;border:none;color:#FFF;background-color:rgb(51, 51, 51); margin-top:9px; margin-bottom:2em;"/>
                                        <div class="d-flex justify-content-end">
                                            <button type="button" class="btn btn-primary" @click="evtMostrarModalReasignacion({ esMultiple: false })"><i class="fas fa-exchange-alt"></i>&nbsp;&nbsp;Cambiar notificador</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL CONFIRMAR REASIGNACION -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-confirmacion-reasignacion">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>Selecciona al notificador</h6>
                            <C020Notificadores v-if="cambioDeNotificador.catalogoNotificadores.lista.filter(n => n.Activo) != null && 
                                                     cambioDeNotificador.catalogoNotificadores.lista.filter(n => n.Activo).length > 0"
                                class="p-0 m-0" 
                                v-on:valorParaElPadre="evtCambioTipoNotificador" 
                                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                                :idDelInput="cambioDeNotificador.catalogoNotificadores.ID" 
                                :listaDeNotificadores="cambioDeNotificador.catalogoNotificadores.lista.filter(n => n.Activo)"
                                :parametros="{}" 
                                :valorDefinido="cambioDeNotificador.catalogoNotificadores.valorDefinido" 
                                :key="cambioDeNotificador.catalogoNotificadores.KEY + cambioDeNotificador.catalogoNotificadores.contRender"
                                :filtrarPorJurisdiccion="true"></C020Notificadores>
                        </div>
                    </div>  
                    <div class="modal-footer">
                        <div class="d-flex justify-content-end">
                            <button  type="button" class="btn btn-danger" @click="limpiarInputsDeAsignacion({ conCatalogoNotificador: true, conSeleccionEnTabla: false, conModal: true })"><i class="fas fa-times"></i>&nbsp;&nbsp;Cancelar</button>
                            <button type="button" class="btn btn-success ml-4" @click="iniciarProcesoReasignacionDeCedulas()"><i class="fas fa-save"></i>&nbsp;&nbsp;Guardar</button>
                        </div>
                    </div>           
                </div>
            </div>
        </div>
        <!-- MODAL INOFRMACION HISTORIAL DE ASIGNACIONES -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informacion-historial-asignaciones">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Historial de asignaciones a la cedula [Folio: #{{ (campoEsValido({ campoAValidar: cedulaSeleccionada })) ? cedulaSeleccionada.CedulaId : '' }}]</h5>
                        <button id="btn-cerrar-modal-informacion-historial-asignaciones" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <div class="contenedor-tabla-asignacionesV2-SINOJ">
                                <table
                                    class="table table-striped table-light table-hover"
                                    :id="historial.tabla.ID"              
                                    data-toggle="table"
                                    data-pagination="true"
                                    data-undefined-text="Sin información"
                                    data-maintain-selected="true"  
                                    data-page-size = "5"
                                    data-page-list="[3,5,10,20]"
                                    data-click-to-select="false"
                                    data-show-toggle="false"
                                    data-show-pagination-switch="false"
                                    data-search="false">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th data-halign="center" data-width="25" data-align="center" data-field="FechaAsignacionSTR" data-sortable="true">
                                                Fecha de asignacion
                                            </th>
                                            <th data-halign="center" data-width="25" data-align="center" data-field="NotificadorSTR" data-sortable="true">
                                                Notificador
                                            </th>
                                            <th data-halign="center" data-width="25" data-align="center" data-field="AreaSTR" data-sortable="true">
                                                Area
                                            </th>
                                            <th data-halign="center" data-width="23" data-align="center" data-field="EstatusSTR" data-sortable="true">
                                                Estatus
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>        
                </div>
            </div>
        </div>
        <!-- MODAL SELECCION DE CEDULAS PARA REPORTE -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="creacion-reporte-asignaciones-notificadores">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Reporte asignaciones de notificadores</h5>
                        <button id="btn-cerrar-creacion-reporte-asignaciones-notificadores" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div id="contenedor-inf-reporte-general" class="alert alert-secondary text-justify" role="alert">
                            <h5><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Nota</h5>
                            <h6>Solo se generara el reporte de notificadores que tengan cédulas asignadas con la fecha ingresada en el campo <strong>[Periodo en que se recibieron las cédulas del juzgado]</strong>, El reporte incluye cédulas finalizadas y regresadas al juzgado.</h6>
                        </div>
                        <h6>Periodo en que se recibieron las cédulas del juzgado</h6>
                        <div class="d-flex mt-2 mb-2">
                            <div class="form-group pl-0 pr-0 col-5">
                                <input v-model="reporteGeneralAsignaciones.fechaInicial" type="date" class="form-control flex-grow-1" />
                            </div>
                            <div class="col-2 d-flex justify-content-center">
                                <h6>a</h6>
                            </div>
                            <div class="form-group pl-0 pr-0 col-5">
                                <input v-model="reporteGeneralAsignaciones.fechaFinal" type="date" class="form-control flex-grow-1" />
                            </div>
                        </div>
                        <i v-if="reporteGeneralAsignaciones.errorEnFechas" class="text-danger">(*) Las fechas no pueden estar vacias, tener la fecha inicial mayor a la fecha final y la fecha final menor a la fecha inicial.</i>
                    </div>      
                    <div class="modal-footer">
                        <div class="d-flex justify-content-end">
                            <button  type="button" @click="iniciarProcesoCreacionReporteGeneralAsignaciones" class="btn btn-info"><i class="fas fa-file-alt"></i>&nbsp;&nbsp;Generar</button>
                        </div>
                    </div>       
                </div>
            </div>
        </div>
         <!-- MODAL CON VISUALIZADOR DE REPORTE -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visualizador-reporte-notificador-asignaciones">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Reporte generado</h5>
                        <button id="btn-cerrar-visualizador-reporte-notificador-asignaciones" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <PDFDocument 
                            :url="reporte.visualizador.url" 
                            :ArchivoAConvertir="reporte.visualizador.archivoDeReporte"
                            :EsBase64="EsBase64"
                            :EsBlob = "EsBlob"
                            :height="reporte.visualizador.height"
                            :key="'VACANOT' + reporte.visualizador.contRender" />
                    </div>           
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { campoEsValido, convertirCadenaAMayusculas, areasAFiltrarParaDireccion } from "../../../../Comun/Funciones/validaciones.js"
import enumeraciones from '@/../static/js/enumeraciones'
import sistemas from '@/../static/js/sistemas'
import comun from "@/../static/js/comun"
import api from '@/../static/js/api'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import VueMask from 'v-mask'
import { servicioRestPost } from '../../../../../Audiencias/Programacion/servicios/ServiciosHttp.js'

Vue.use(VueMask);
export default {
    components: {
        C020Notificadores: catalogos.SINOJ.C020Notificadores,
        C001Area: catalogos.PJ.C001Area,
        PDFDocument
    },
    data() {
        return {
            EsBlob:{},
            EsBase64:{},
            enumeraciones,
            campoEsValido,
            areasAFiltrarParaDireccion,        
            filtros: {
                catalogoJuzgado: {
                    ID: 'F-JUZGADO-ASIG-SINOJ',
                    KEY: 'K-JUZGADO-ASIG-SINOJ',
                    selccionado: null,
                    valorDefinido: -1,
                    contRender: 0,
                    parametros: { conPartidoJudicial: true, conMaterias: true,
                     Materias: [ { MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 13, Activo: true }, { MateriaId: 1, Activo: true }, { MateriaId: 12, Activo: true } ],
                     elementosAOmitir: [26]
                    }
                },
                fechaInicial: moment().format('YYYY-MM-DD'),
                fechaFinal: moment().format('YYYY-MM-DD'),
                numeroExpediente: null
            },
            tablaAsignaciones: {
                ID: 'T-Asignaciones-SINOJ',
                listaOriginal: [],
                listaParaTabla: [],
                seleccionadas: []
            },
            cedulaSeleccionada: null,
            cambioDeNotificador: {
                catalogoNotificadores: {
                    ID: 'C-TNotificadores-SINOJ',
                    KEY: 'K-TNotificadores-SINOJ',
                    contRender: 0,
                    lista: [],
                    valorDefinido: -1,
                    seleccionado: null
                }
            },
            esReasignacionMultiple: false,
            historial: {
                cedula: null,
                asignaciones: [],
                tabla: {
                    ID: 'T-Historial-Asignaciones-SINOJ'
                }
            },
            reporteGeneralAsignaciones: {
                fechaInicial: moment().format('YYYY-MM-DD'),
                fechaFinal: moment().add(1, 'days').format('YYYY-MM-DD'),
                errorEnFechas: false
            },
            reporte: {
                visualizador: {
                    url: null,
                    height: '500px',
                    archivoDeReporte: null,
                    contRender: 0
                }
            },
            ASIGNAR_POR_NOTIFICADOR: {
                activo: false,
                catalogoNotificadores: {
                    ID: 'C-TNotificadores-OPSAPN-SINOJ',
                    KEY: 'K-TNotificadores-OPSAPN-SINOJ',
                    contRender: 0,
                    lista: [],
                    valorDefinido: -1,
                    seleccionado: null,
                    mostrarGeneracionListado: false
                }
            }
        }
    },
    methods: {
        downloadReportAsignacionesNotificador: async function({ conLoading }) {
            if(conLoading)
                comun.SeEstaCargandoInformacion(true);

            try {
                const PARAMETROS_REPORTE = { 
                    CedulasParaReporte: this.tablaAsignaciones.listaParaTabla
                    .filter(c => c.NotificadorSTR == this.obtenerNombreNotificador({ notificadorObj: this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.seleccionado }))
                    .map(a => {
                        let cedulaObj = {};
                        cedulaObj.Consecutivo = a.Expediente.NumeroDeDocumento;
                        cedulaObj.TipoDocumento = a.Expediente.TipoDocumento.Nombre;
                        cedulaObj.Domicilio = a.DomicilioSTR;
                        cedulaObj.Folio = a.CedulaId;
                        cedulaObj.Juzgado = a.Expediente.Juzgado.Nombre;
                        cedulaObj.PersonaANotificar = a.PersonaANotificarSTR;
                        cedulaObj.TipoCedula = a.TipoCedula.Nombre;
                        return cedulaObj;
                    }),
                    Notificador: this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.seleccionado
                }

                if(campoEsValido({ campoAValidar: PARAMETROS_REPORTE.CedulasParaReporte })) {
                    const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                        servicioUrl: api.SINOJ.sistema.cedulas.asignacion.GetReportAsigancionesDeNotificador,
                        peticionServicio: PARAMETROS_REPORTE,
                        headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: true }
                    }));

                    if(!CON_ERROR) {
                        console.log('ArrayBuffer::', RESPUESTA);
                        if(RESPUESTA.byteLength > 0) {
                            let blobFileReport = new Blob([RESPUESTA], { type: 'application/pdf' });
                            let url = window.URL.createObjectURL(blobFileReport);
                            let link = document.createElement("a");
                            link.download = 'ReporteDeAsignaciones';
                            link.href = url;
                            link.click();
                        }
                        else {
                            comun.mensajeDeAlerta('Ocurrio un error al generar el reporte, vuelve intentarlo.');
                        }
                    }
                }
                else {
                    comun.mensajeDeAlerta('El notificador seleccionado no cuenta con ninguna cedula asignada');
                }
            }
            catch(e) {
                comun.mensajeDeAlerta('Ocurrio un error al generar el reporte, vuelve intentarlo.');
                console.error(e);
            }

            if(conLoading)
                comun.SeEstaCargandoInformacion(false);
        },
    
        evtCambioNotificadorAsigancionPorNotificador: function(evento, notificadorObj) {
            this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.valorDefinido = parseInt(evento.target.value);
            this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.seleccionado = (parseInt(evento.target.value) > 0) ? notificadorObj : null;
            //console.log('seleccionado::',this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.seleccionado);
            this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.mostrarModalReporteGeneralDeAsignaciones = false;
        },
        evtAsignarPorNotificador: function() {
            this.ASIGNAR_POR_NOTIFICADOR.activo = !this.ASIGNAR_POR_NOTIFICADOR.activo;
            if(this.ASIGNAR_POR_NOTIFICADOR.activo) {
                this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.valorDefinido = -1;
                this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.contRender ++;
            }

            this.$nextTick(() => {
                $("#" + this.tablaAsignaciones.ID).bootstrapTable('uncheckAll');
                this.tablaAsignaciones.seleccionadas = [];
                this.cedulaSeleccionada = null;
            });
        },
        fechasDeReporteIncorrectas: function() { 
            let esIncorrecto = (this.reporteGeneralAsignaciones.fechaInicial != null && this.reporteGeneralAsignaciones.fechaFinal != null) 
                ? (this.reporteGeneralAsignaciones.fechaInicial > this.reporteGeneralAsignaciones.fechaFinal || this.reporteGeneralAsignaciones.fechaFinal < this.reporteGeneralAsignaciones.fechaInicial)
                    ? true : false
                : true;
            return esIncorrecto;
        },
        iniciarProcesoCreacionReporteGeneralAsignaciones: async function() { 
            this.reporteGeneralAsignaciones.errorEnFechas = this.fechasDeReporteIncorrectas();
            if(!this.reporteGeneralAsignaciones.errorEnFechas) {
                $("#creacion-reporte-asignaciones-notificadores").modal('hide');
                const { fechaInicial, fechaFinal } = this.reporteGeneralAsignaciones;
                const PETICION_API = { FechaInicial: fechaInicial, FechaFinal: fechaFinal, EsPrueba: false };
                let REPORTE_SIN_ERROR = await Promise.resolve(this.obtenerReporteGeneralAsignacionesBD({ peticion: PETICION_API }));
                console.log("REPORTE_SIN_ERROR:::",REPORTE_SIN_ERROR)
                if(REPORTE_SIN_ERROR) {
                    console.log("esbase644444:: ",this.EsBase64)
                    $('#visualizador-reporte-notificador-asignaciones').modal('show');
                    this.reporte.visualizador.contRender ++;
                }
                else
                    comun.mensajeDeAlerta('No se encontró información con los parámetros ingresados.');
            }
        },
        obtenerReporteGeneralAsignacionesBD: async function({ peticion }) { 
            let seObtuvoReporte = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.reportes.reporteAsignacionesNotificadores.ObtenerReporteDeAsignacionesNotificadores;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionArchivos = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal);
                comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticion, headerPeticion);
                const DATOS = await RESPUESTA_SOLICITUD.data;
                console.log("DATOS:::::",await RESPUESTA_SOLICITUD.data)
                //if(DATOS.byteLength > 0) {
                     this.EsBase64={
                                   esBase64:true,
                                   archivoBase64:DATOS.ArchivoBase64
                                   }
                    // this.EsBlob = {
                    //     esBlob:true,
                    //     blob: DATOS.RutaDeServidor
                    // }
                    this.reporte.visualizador.archivoDeReporte = new File([DATOS], 'ReporteGeneralDeAsignaciones', { type: 'application/pdf' });
                    console.log("datosssss::: ",this.reporte.visualizador.archivoDeReporte)
                    seObtuvoReporte = true;
               // }
                comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                comun.SeEstaCargandoInformacion(false);
                console.log(excepcion);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return seObtuvoReporte;
        },
        mostrarModalReporteGeneralDeAsignaciones: function() {
            $("#creacion-reporte-asignaciones-notificadores").modal('show');
        },
        iniciarProcesoMostrarHistorialDeAsignaciones: async function() { debugger
            const PETICION_API = { Cedula: { CedulaId: parseInt(this.historial.cedula.CedulaId), Urgente: false, FechaDeRegistro: new Date() }, EsPrueba: false };
            const { asignaciones } = await Promise.resolve(this.obtenerHistorialDeAsignacionesCedulaDB({ peticion: PETICION_API }));
            if(campoEsValido({ campoAValidar: asignaciones })) {
                this.historial.asignaciones = await Promise.resolve(this.darFormatoAObjetoAsignacion({ asignaciones: asignaciones }));
                await Promise.resolve(this.inicializarTablaHistorialAsignaciones({ elementos: this.historial.asignaciones }));
                this.manipularVisualizacionModal({ idModal: 'modal-informacion-historial-asignaciones', mostrar: true });
            }
        },
        inicializarTablaHistorialAsignaciones: async function({ elementos }) {             
            this.$nextTick(() => {
                $("#" + this.historial.tabla.ID).bootstrapTable({  data: elementos });      
                $("#" + this.historial.tabla.ID).bootstrapTable('load', elementos ); 
            });
        },
        darFormatoAObjetoAsignacion: async function({ asignaciones }) {
            moment.locale('es');
            return asignaciones.map(a => {
                a.FechaAsignacionSTR = moment(a.FechaDeAsignacion).format("DD MMMM YYYY");
                a.NotificadorSTR = (campoEsValido({ campoAValidar: a.Usuario })) ? this.obtenerNombreNotificador({ notificadorObj: { Usuario: a.Usuario } }) : 'No se encontró información del notificador registrado en la asignación';
                a.AreaSTR = (campoEsValido({ campoAValidar: a.Usuario }) && campoEsValido({ campoAValidar: a.Usuario.AreaAsignado })) ? a.Usuario.AreaAsignado.Nombre : 'No se encontró información acerca del área del notificador registrado en la asignación';
                a.EstatusSTR = (a.Activo) 
                    ? '<div style="display: flex; justify-content: center; align-items: center; background-color: rgb(6, 77, 6); color: white; padding: 3px 3px 0 3px;"><h6 style="font-size: 1.3em;">Asignación activa</h6></div>' 
                    : '<div style="display: flex; justify-content: center; align-items: center; background-color: rgb(99, 4, 4); color: white; padding: 3px 3px 0 3px;"><h6 style="font-size: 1.3em;">Asignación inactiva</h6></div>';
                return a;
            });
        },
        obtenerHistorialDeAsignacionesCedulaDB: async function({ peticion, visualizarCargaDeInformacion = true }) { debugger
            let estatusProceso = { conError: true, asignaciones: [] };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.cedulas.asignacion.ObtenerHistorialDeAsignaciones;;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Asignaciones } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    estatusProceso.conError = false;
                    estatusProceso.asignaciones = Asignaciones;
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return estatusProceso;
        },
        evtMostrarModalReasignacion: async function({ esMultiple, esParaRemover = false }) {
            this.esReasignacionMultiple = esMultiple;
            if(!esParaRemover)
                this.manipularVisualizacionModal({ idModal: 'modal-confirmacion-reasignacion', mostrar: true });
            else
                await Promise.resolve(this.iniciarProcesoReasignacionDeCedulas());
        },
        iniciarProcesoReasignacionDeCedulas: async function() {
            this.manipularVisualizacionModal({ idModal: 'modal-confirmacion-reasignacion', mostrar: false })
            const { valorDefinido } = this.cambioDeNotificador.catalogoNotificadores;
            const seleccionadas = (this.esReasignacionMultiple) ? this.tablaAsignaciones.seleccionadas : [this.cedulaSeleccionada];
            const HAY_NOTIFICADOR_SELECCIONADO = campoEsValido({ campoAValidar: valorDefinido });
            const PUEDE_INICIAR_PROCESO = (this.esReasignacionMultiple) ? true : HAY_NOTIFICADOR_SELECCIONADO;
            if(PUEDE_INICIAR_PROCESO) {
                comun.SeEstaCargandoInformacion(true);
                const PETICION_API = { Cedulas: seleccionadas, NotificadorId: (HAY_NOTIFICADOR_SELECCIONADO) ? valorDefinido : null, EsPrueba: false };
                const { cedulasActualizadas, mensaje } = await Promise.resolve(this.reasignarCedulasDB({ peticion: PETICION_API, visualizarCargaDeInformacion: false }));
                if(campoEsValido({ campoAValidar: cedulasActualizadas })) {
                    this.limpiarInputsDeAsignacion({ conCatalogoNotificador: true, conSeleccionEnTabla: true, conModal: false });
                    await Promise.resolve(this.actualizarFilasEnTabla({ filasParaActualizar: cedulasActualizadas }));
                    comun.mensajeDeAlerta(mensaje);
                }
                comun.SeEstaCargandoInformacion(false);
            }
        },
        actualizarFilasEnTabla: async function({ filasParaActualizar }) {
            let filasConFormato = await Promise.resolve(this.formatearCedulasParaTabla({ cedulas: filasParaActualizar }));

            // se actualizan las nuevas asignaciones a las cedulas en las listas de datos
            filasParaActualizar.forEach(f => {
                let INDEX_FILA_EN_LISTA = this.tablaAsignaciones.listaOriginal.findIndex(cDB => cDB.CedulaId == f.CedulaId);
                if(INDEX_FILA_EN_LISTA >= 0) {
                    this.tablaAsignaciones.listaOriginal[INDEX_FILA_EN_LISTA] = f;
                }
            });
            this.$nextTick(() => { 
                filasConFormato.forEach(fila => {   
                    let INDEX_FILA_EN_LISTA = this.tablaAsignaciones.listaParaTabla.findIndex(cT => cT.CedulaId == fila.CedulaId);
                    if(INDEX_FILA_EN_LISTA >= 0) {
                        this.tablaAsignaciones.listaParaTabla[INDEX_FILA_EN_LISTA] = fila;
                    }

                    $("#" + this.tablaAsignaciones.ID).bootstrapTable('updateByUniqueId', {
                        id: fila.CedulaId,
                        row: fila
                    });
                });
            });
        },
        limpiarInputsDeAsignacion: function({ conCatalogoNotificador = true, conSeleccionEnTabla = true, conModal = false }) {
            if(conModal) {
                this.manipularVisualizacionModal({ idModal: 'modal-confirmacion-reasignacion', mostrar: false });
            }

            if(conCatalogoNotificador) {
                this.cambioDeNotificador.catalogoNotificadores.valorDefinido = -1;
                this.cambioDeNotificador.catalogoNotificadores.contRender ++;
            }

            if(conSeleccionEnTabla) {
                this.$nextTick(() => {
                    $("#" + this.tablaAsignaciones.ID).bootstrapTable('uncheckAll');
                    this.tablaAsignaciones.seleccionadas = [];
                });
            }

            if(!conModal)
                this.cedulaSeleccionada = null;
        },
        reasignarCedulasDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            let estatusProceso = { conError: true, cedulasActualizadas: [], mensaje: null };
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_ACTUALIZAR = api.SINOJ.sistema.cedulas.asignacion.RemoverAsignacionDeCedulas;
                let urlApi = SERVIDOR + METODO_API_ACTUALIZAR;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Cedulas, Satisfactorio } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                } 
                else { 
                    estatusProceso.conError = false;
                    estatusProceso.cedulasActualizadas = Cedulas;
                    estatusProceso.mensaje = Satisfactorio;
                    await Promise.resolve(this.obtenerCatalogoDeNotificadoresConAsignacionBD({ conActaulizacionDeCatalogo: true }));
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
            return estatusProceso;
        },
        manipularVisualizacionModal: function({ idModal, mostrar }) { 
            const ACCION = (mostrar) ? 'show' : 'hide';
            $('#' + idModal).modal(ACCION);
        },
        evtCambioTipoNotificador: function(evento) {
            this.cambioDeNotificador.catalogoNotificadores.valorDefinido = parseInt(evento.target.value);
        },
        evtCambioDeJuzgado: function(evento) {
            this.filtros.catalogoJuzgado.valorDefinido = parseInt(evento.target.value);
        },
        evtCedulasSeleccionadas: function({ agregar, seleccionadas }) {            
            //this.tablaAsignaciones.seleccionadas = (agregar) ? this.tablaAsignaciones.listaOriginal : []; 
            if(agregar) {
                this.tablaAsignaciones.seleccionadas = this.tablaAsignaciones.listaOriginal
                    .filter(cedulaOriginal => seleccionadas.some(cedulaSeleccionada => cedulaSeleccionada.CedulaId == cedulaOriginal.CedulaId));
            }
            else {
                this.tablaAsignaciones.seleccionadas = [];
            }
            console.log('evtCedulasSeleccionadas::', this.tablaAsignaciones.seleccionadas);
            //alert("estatus::" + this.tablaAsignaciones.seleccionadas.length);
        },
        evtCedulaSeleccionada: function({ agregar, cedula }) { 
            const CEDULA_SELECCIONADA = this.tablaAsignaciones.listaOriginal.find(cDB => cDB.CedulaId == cedula.CedulaId);
            if(agregar) {
                if(campoEsValido({ campoAValidar: CEDULA_SELECCIONADA })) {
                    const CEDULA_AGREGADA_PREVIAMENTE = this.tablaAsignaciones.seleccionadas.some(cS => cS.CedulaId == CEDULA_SELECCIONADA.CedulaId);
                    if(!CEDULA_AGREGADA_PREVIAMENTE)
                        this.tablaAsignaciones.seleccionadas.push(CEDULA_SELECCIONADA);
                }
            }
            else {
                this.tablaAsignaciones.seleccionadas = this.tablaAsignaciones.seleccionadas.filter(cS => cS.CedulaId != CEDULA_SELECCIONADA.CedulaId);
            }
        },
        inicializarTabla: async function({ elementos }) { 
            this.$nextTick(() => {                
                $("#" + this.tablaAsignaciones.ID).off("check.bs.table uncheck.bs.table check-all.bs.table uncheck-all.bs.table click-row.bs.table");
                $("#" + this.tablaAsignaciones.ID).bootstrapTable({  data: elementos });      
                $("#" + this.tablaAsignaciones.ID).bootstrapTable('load', elementos ); 

                // eventos
                $("#" + this.tablaAsignaciones.ID).on('check.bs.table',(e, row) => {
                    this.evtCedulaSeleccionada({ agregar: true, cedula: row });
                });
                $("#" + this.tablaAsignaciones.ID).on('uncheck.bs.table',(e, row) => {
                    this.evtCedulaSeleccionada({ agregar: false, cedula: row });
                });
                $("#" + this.tablaAsignaciones.ID).on('check-all.bs.table',(e, rows, rowsAfter, rowsBefore) => {                     
                    var allRows = $("#" + this.tablaAsignaciones.ID).bootstrapTable('getData'); 
                    //console.log("check-all allRows::",allRows);                    
                    allRows.forEach(function(row) {
                        if(row.hasOwnProperty('0'))
                            return;
                        else{
                             row['0'] = true;
                        }
                    });
                    
                    console.log("check-all rows::",rows);
                    this.evtCedulasSeleccionadas({ agregar: true, seleccionadas: rows }); 
                });
                $("#" + this.tablaAsignaciones.ID).on('uncheck-all.bs.table',(e, rows, rowsAfter, rowsBefore) => {   
                    var allRows = $("#" + this.tablaAsignaciones.ID).bootstrapTable('getData');   
                    //console.log("uncheck-all allRows::",allRows);                      
                    allRows.forEach(function(row) {
                        if(row.hasOwnProperty('0'))
                            delete row['0'];
                    });
                    //console.log("uncheck-all rows::",rows);
                    this.evtCedulasSeleccionadas({ agregar: false, seleccionadas: [] }); 
                });
                $("#" + this.tablaAsignaciones.ID).on('click-row.bs.table',(e, row, field) => {
                    this.evtSeleccionDeCedulaPorFila({ cedula: row });
                    $('.custom--success').removeClass('custom--success');
                    $(field).addClass('custom--success');
                });
            });
        },
        evtSeleccionDeCedulaPorFila: function({ cedula }) {
            this.cedulaSeleccionada = cedula;
        },
        iniciarProcesoBusquedaDeCedulas: async function({ busquedaPorNotificador = false }) {
            if(!busquedaPorNotificador)
                await Promise.resolve(this.busquedaPorJuzgado());
            else
                await Promise.resolve(this.busquedaPorNotificador());
        },
        busquedaPorNotificador: async function() {
            const { catalogoNotificadores } = this.ASIGNAR_POR_NOTIFICADOR;
            if(campoEsValido({ campoAValidar: catalogoNotificadores.valorDefinido })) {
                // se limpian las variables de la selecciona anterior (por juzgado y fecha)
                this.$nextTick(() => {
                    $("#" + this.tablaAsignaciones.ID).bootstrapTable('uncheckAll');
                    this.tablaAsignaciones.seleccionadas = [];
                    this.cedulaSeleccionada = null;
                });

                const PRTICION_API = { 
                    JuzgadoId:  null, 
                    NumeroDeDocumento: null,
                    FechaInicial:  null, 
                    FechaFinal:  null, 
                    NotificadorId: catalogoNotificadores.valorDefinido,
                    EsPrueba: false };
                await Promise.resolve(this.obtenerCedulasDB({ peticion: PRTICION_API }));
            }
            else {
                comun.mensajeDeAlerta('Debes sleccionar a un notificador del catalogo');
            }
        },
        busquedaPorJuzgado: async function() {
            const { catalogoJuzgado, numeroExpediente, fechaInicial, fechaFinal } = this.filtros;
            if(campoEsValido({ campoAValidar: catalogoJuzgado.valorDefinido })) {
                this.cedulaSeleccionada = null;
                const PRTICION_API = { 
                    JuzgadoId: (campoEsValido({ campoAValidar: catalogoJuzgado.valorDefinido })) ? catalogoJuzgado.valorDefinido : null, 
                    NumeroDeDocumento: numeroExpediente,
                    FechaInicial: (campoEsValido({ campoAValidar: fechaInicial })) ? fechaInicial : null, 
                    FechaFinal: (campoEsValido({ campoAValidar: fechaFinal })) ? fechaFinal : null, 
                    EsPrueba: false };
                await Promise.resolve(this.obtenerCedulasDB({ peticion: PRTICION_API }));
            }
            else {
                comun.mensajeDeAlerta('Debes ingresar un juzgado para realizar la busqueda');
            }
        },
        obtenerCedulasDB: async function({ peticion, visualizarCargaDeInformacion = true }) { 
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SINOJ.sistema.cedulas.asignacion.ObtenerCedulasParaAsignacion;
                let urlApi = SERVIDOR + METODO_API_OBTENER;
                let peticionAPI = peticion;
                const HEADER_PARA_ENVIO_ARCHIVOS = false;
                const HEADER_PARA_ARRAY_BUFFER = false;
                let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS,HEADER_PARA_ARRAY_BUFFER);
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(true);
                const RESPUESTA_SOLICITUD = await axios.post(urlApi, peticionAPI, headerPeticion);
                const DATOS_RESPUESTA = await RESPUESTA_SOLICITUD.data;
                let { SiHayError, Error, Cedulas } = DATOS_RESPUESTA;
                if (SiHayError) {
                    let mensajeError = Error.Mensaje;
                    console.log(Error);
                    if(visualizarCargaDeInformacion)
                        comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(mensajeError);
                    await Promise.resolve(this.inicializarTabla({ elementos: [] }));
                } 
                else { 
                    this.tablaAsignaciones.listaOriginal = (campoEsValido({ campoAValidar: Cedulas })) ? Cedulas : [];
                    console.log('cedulaDB::',this.tablaAsignaciones.listaOriginal);
                    this.tablaAsignaciones.listaParaTabla  = await Promise.resolve(this.formatearCedulasParaTabla({ cedulas: Cedulas }));
                    await Promise.resolve(this.inicializarTabla({ elementos: this.tablaAsignaciones.listaParaTabla }));
                    this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.mostrarModalReporteGeneralDeAsignaciones = true;
                }
                if(visualizarCargaDeInformacion)
                    comun.SeEstaCargandoInformacion(false);
            }
            catch(excepcion) {
                console.log(excepcion);
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
            }
        },
        formatearCedulasParaTabla: async function({ cedulas }) {
            moment.locale('es');
            let listaDeCedulas = [];
            if(campoEsValido({ campoAValidar: cedulas })) {
                listaDeCedulas = cedulas.map(cDB => {
                    let cedulaObj = { ...cDB };
                    cedulaObj.fechaRecepcionSTR = moment(cDB.FechaDeEnvio).format("DD MMMM YYYY")
                    cedulaObj.DomicilioSTR = 'Sin Domicilio';
                    cedulaObj.PersonaANotificarSTR = 'Sin Persona a Notificar';
                    cedulaObj.NotificadorSTR = (campoEsValido({ campoAValidar: cDB.Notificador })) ? this.obtenerNombreNotificador({ notificadorObj: cDB.Notificador }) : 'Sin asignación';
                    if(campoEsValido({ campoAValidar: cDB.PersonasANotificar })) {
                        cedulaObj.PersonaANotificarSTR = this.obtenerNombrePersonaANotificar({ persona: cDB.PersonasANotificar[0] });
                        if(campoEsValido({ campoAValidar: cDB.PersonasANotificar[0].Domicilios })) {
                            const DOMICILIO_OBJ = cDB.PersonasANotificar[0].Domicilios[0];
                            cedulaObj.DomicilioSTR = this.obtenerNombreDeDomicilio({ domicilio: DOMICILIO_OBJ });
                        }
                    }
                    cedulaObj.fehaAudienciaSTR = "Sin fecha";
                    cedulaObj.fehaAutoSTR = "Sin fecha";
                    cedulaObj.fechaCreacionSTR = (campoEsValido({ campoAValidar: cDB.FechaDeRegistro }))
                            ? moment(cDB.FechaDeRegistro).format('DD MMMM YYYY') 
                            : cedulaObj.fechaCreacionSTR;
                    const ACUERDO_PRINCIPAL = cDB.Acuerdos.find(a => a.EsPrincipal);
                    if(campoEsValido({ campoAValidar: ACUERDO_PRINCIPAL })) {
                        cedulaObj.fehaAudienciaSTR = (campoEsValido({ campoAValidar: ACUERDO_PRINCIPAL.FechaDeAudiencia }))
                            ? moment(ACUERDO_PRINCIPAL.FechaDeAudiencia).format('DD MMMM YYYY hh:mm a') 
                            : cedulaObj.fehaAudienciaSTR;
                        cedulaObj.fehaAutoSTR = (campoEsValido({ campoAValidar: ACUERDO_PRINCIPAL.FechaDePublicacion }))
                            ? moment(ACUERDO_PRINCIPAL.FechaDePublicacion).format('DD MMMM YYYY') 
                            : cedulaObj.fehaAutoSTR;
                    }
                    return cedulaObj;
                });
            }
            return listaDeCedulas;
        },
        obtenerNombrePersonaANotificar: function({ persona }) {
            let nombreDePersona = 'Sin Persona a Notificar';
            const { DatosGenerales } = persona;
            if(campoEsValido({ campoAValidar: DatosGenerales })) {
                const { Fisica, Moral } = DatosGenerales;
                if(campoEsValido({ campoAValidar: Fisica }))
                    nombreDePersona = `${ convertirCadenaAMayusculas({ cadena: Fisica.Nombre }) } ${ convertirCadenaAMayusculas({ cadena: Fisica.ApellidoPaterno }) }${ (campoEsValido({ campoAValidar: Fisica.ApellidoMaterno })) ? (" " + Fisica.ApellidoMaterno.toUpperCase().trim()) : "" }`; 
                else if(campoEsValido({ campoAValidar: Moral }))
                    nombreDePersona = `${ Moral.Nombre.trim() }`; 
            }
            return nombreDePersona;
        },
        
        obtenerNombreDeDomicilio: function({ domicilio }) {
            let nombreDeDomicilio = 'Sin domicilio';
            let infAdicionalNumExt = (campoEsValido({ campoAValidar: domicilio.InformacionAdicionalDeNumeroExterior })) ? ` ${ domicilio.InformacionAdicionalDeNumeroExterior }` : '';
            let numInterior = (campoEsValido({ campoAValidar: domicilio.NumeroInterior })) ? `int ${ domicilio.NumeroInterior.toString().trim() }` : '';
            if(campoEsValido({ campoAValidar: domicilio.Fraccionamiento })) {
                nombreDeDomicilio = `${ domicilio.Calle } #${ domicilio.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ domicilio.Fraccionamiento.Nombre }, ${ domicilio.Fraccionamiento.Municipio.Nombre }`;
            }
            else {
                let fraccionamientoCompuesto = domicilio.FraccionamientoFueraDeCatalogo.split(',');
                let nombreFraccionamiento = fraccionamientoCompuesto[0];
                let nombreMunicipio = fraccionamientoCompuesto[1];
                nombreDeDomicilio = `${ domicilio.Calle } #${ domicilio.NumeroExterior }${ infAdicionalNumExt } ${ numInterior }, ${ nombreFraccionamiento }, ${ nombreMunicipio }`;
            }
            return nombreDeDomicilio;
        },
        obtenerNombreNotificador: function({ notificadorObj }) {
            const { Usuario } = notificadorObj;
            const DATOS_DE_NOMBRE = [Usuario.Nombre, Usuario.ApellidoPaterno, Usuario.ApellidoMaterno];
            return DATOS_DE_NOMBRE.join(' ');
        },
        obtenerHTMLAcciones: () => {
            return [
                '<div>',
                    '<button id="btn-ver-asignaciones-SINOJ-accion" title="Ver historial de asignaciones" type="button" class="btn-ver-asignaciones-SINOJ btn btn-light btn-sm btn-xs btn-lg btn-md mr-2"><i class="fas fa-eye"></i></button>',
                '</div>'
            ].join("");
        },
        obtenerCatalogoDeNotificadoresBD: async function() { 
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.catalogos.C020TiposNotificadores;
            const URL_SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = { NotififadorId: null, ZonaId: null, ConInactivos: true, ConZona: false, ConCedulas: false, ConSalidas:false, ConAsignacionDeFraccionamientos: false };
            peticionAPI.EsPrueba = false;
            peticionAPI.ConAreaDeUsuario = true;
            const HEADER_PARA_ENVIO_ARCHIVOS = false;
            const HEADER_PARA_ARRAY_BUFFER = false;
            const HEADER_SERVICIO_REST = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS, HEADER_PARA_ARRAY_BUFFER);
            comun.SeEstaCargandoInformacion(true);
            const RESPUESTA = await axios.post(URL_SERVICIO_REST, peticionAPI, HEADER_SERVICIO_REST);
            const DATOS_RESPUESTA = await RESPUESTA.data;
            let { SiHayError, Error, Notificadores } = DATOS_RESPUESTA;
            if (SiHayError) {
                const MENSAJE_ERROR = Error.Mensaje;
                console.log(Error);
                comun.SeEstaCargandoInformacion(false);
                console.log(MENSAJE_ERROR);
            } 
            else { 
                this.cambioDeNotificador.catalogoNotificadores.lista = Notificadores;
                /* this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.lista = Notificadores; */
                console.log('Notificadores::',this.cambioDeNotificador.catalogoNotificadores.lista);
            }
            comun.SeEstaCargandoInformacion(false);
          }
          catch(excepcion) {
              console.log(excepcion);
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
        },
        obtenerCatalogoDeNotificadoresConAsignacionBD: async function({ conActaulizacionDeCatalogo }) { 
          try {
            const SERVIDOR = api.conexion;
            const METODO_API_OBTENER = api.SINOJ.catalogos.C020TiposNotificadoresConAsignacion;
            const URL_SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
            let peticionAPI = { NotififadorId: null, ZonaId: null, ConInactivos: true, ConZona: false, ConCedulas: false, ConSalidas:false, ConAsignacionDeFraccionamientos: false };
            peticionAPI.EsPrueba = false;
            peticionAPI.ConAreaDeUsuario = true;
            const HEADER_PARA_ENVIO_ARCHIVOS = false;
            const HEADER_PARA_ARRAY_BUFFER = false;
            const HEADER_SERVICIO_REST = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS, HEADER_PARA_ARRAY_BUFFER);
            comun.SeEstaCargandoInformacion(true);
            const RESPUESTA = await axios.post(URL_SERVICIO_REST, peticionAPI, HEADER_SERVICIO_REST);
            const DATOS_RESPUESTA = await RESPUESTA.data;
            let { SiHayError, Error, Notificadores } = DATOS_RESPUESTA;
            if (SiHayError) {
                const MENSAJE_ERROR = Error.Mensaje;
                console.log(Error);
                comun.SeEstaCargandoInformacion(false);
                console.log(MENSAJE_ERROR);
            } 
            else { 
                this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.lista = Notificadores;
                if(conActaulizacionDeCatalogo) {
                    // modificacion realizada 18/08/2022
                    let notificadorSeleccionadoTieneAsignaciones = (this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.lista.some(n => n.NotificadorId == this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.valorDefinido));
                    if(!notificadorSeleccionadoTieneAsignaciones) {
                        this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.mostrarModalReporteGeneralDeAsignaciones = false;
                    }
                    this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.valorDefinido = notificadorSeleccionadoTieneAsignaciones ? this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.valorDefinido : -1;
                    this.ASIGNAR_POR_NOTIFICADOR.catalogoNotificadores.contRender ++;
                }
                console.log('NotificadoresConAsignacion::',Notificadores);
            }
            comun.SeEstaCargandoInformacion(false);
          }
          catch(excepcion) {
              console.log(excepcion);
              comun.SeEstaCargandoInformacion(false);
              comun.mensajeDeAlerta(enumeraciones.error.E500, null, null);
          }
        }
    },
    async mounted() {
        window.operateEvents = {
            "click #btn-ver-asignaciones-SINOJ-accion": (e,val,row,index) => {   debugger
                this.historial.cedula = row;
                this.iniciarProcesoMostrarHistorialDeAsignaciones();
            },
        };
        this.filtros.catalogoJuzgado.parametros.SistemaId = 27;
        this.filtros.catalogoJuzgado.parametros.conOrdenamientoPorSistema = true;

        // Filtros de areas.
        let filtrosAreas = areasAFiltrarParaDireccion({ areaDireccion: this.$store.state.Login_Usuario.Area.AreaId, conDireccion: false });

        if(filtrosAreas.elementosAOmitir != undefined || filtrosAreas.elementosAOmitir != null)
            Array.prototype.push.apply(this.filtros.catalogoJuzgado.parametros.elementosAOmitir, filtrosAreas.elementosAOmitir);

        if(filtrosAreas.elementosAConservar != undefined || filtrosAreas.elementosAConservar != null)
            this.filtros.catalogoJuzgado.parametros.elementosAConservar =  filtrosAreas.elementosAConservar;        

        /* await Promise.resolve(this.iniciarProcesoBusquedaDeCedulas()); */
    },
    async created() {
        await Promise.resolve(this.obtenerCatalogoDeNotificadoresConAsignacionBD({ conActaulizacionDeCatalogo: false }));
        await Promise.resolve(this.obtenerCatalogoDeNotificadoresBD());
    },
    computed: {
        mostrarInformacionDeCedula() {
            return campoEsValido({ campoAValidar: this.cedulaSeleccionada })
        },
        mostrarAcciones() {
            return campoEsValido({ campoAValidar: this.tablaAsignaciones.seleccionadas });
        },
        getNUmeroCedulasSeleccionadas() {
            return campoEsValido({ campoAValidar: this.tablaAsignaciones.seleccionadas })
                ? this.tablaAsignaciones.seleccionadas.length
                : 0
        }
    }
}
</script>
<style scoped>
    #f-expediente .input-group-text {
        border-top-left-radius: 0.6vmin;
        border-bottom-left-radius: 0.6vmin;
        border: none;
    }

    #f-expediente .form-control {
        border: none !important;
    }

    #visualizador-reporte-notificador-asignaciones .modal-lg {
        max-width: 70% !important;
    }

    #visualizador-reporte-notificador-asignaciones .modal-header {
        background-color: rgb(36, 34, 34);;
        border: none;
    }

    #creacion-reporte-asignaciones-notificadores .modal-lg {
        max-width: 40% !important;
    }

    #creacion-reporte-asignaciones-notificadores .modal-header {
        background-color: rgb(36, 34, 34);
        border: none;
    }

    #creacion-reporte-asignaciones-notificadores .modal-dialog {
        position: relative;
        top: 40%;
        transform: translateY(-50%);
    }

    #creacion-reporte-asignaciones-notificadores .modal-footer {
        border-top-width: 0.1em;
        border-top-color: rgb(29, 29, 29);
        padding-top: 0.8em;
        padding-bottom: 0.8em;
    }

    #modal-confirmacion-reasignacion .modal-lg {
        max-width: 30% !important;
    }

    #modal-confirmacion-reasignacion .modal-header {
        background-color: rgb(36, 34, 34);
        border: none;
    }

    #modal-confirmacion-reasignacion .modal-dialog {
        position: relative;
        top: 40%;
        transform: translateY(-50%);
    }

    #modal-confirmacion-reasignacion .modal-footer {
        border-top-width: 0.1em;
        border-top-color: rgb(29, 29, 29);
        padding-top: 0.8em;
        padding-bottom: 0.8em;
    }

    #modal-informacion-historial-asignaciones .modal-lg {
        max-width: 60% !important;
    }

    #modal-informacion-historial-asignaciones .modal-header {
        background-color: rgb(36, 34, 34);;
        border: none;
    }

    #modal-informacion-historial-asignaciones .modal-dialog {
        position: relative;
        top: 40%;
        transform: translateY(-50%);
    }

    .filtros .btn-primary {
        background-color: rgb(27, 27, 27);
    }

    .filtros h6 {
        font-weight: bold;
    }

    #secciones-asignacion .card {
        border: 1px solid rgb(44, 44, 44) !important;
    }

    #secciones-asignacion .card-header {
        background-color: black;
    }

    #secciones-asignacion .card-body {
        background-color: rgb(61, 61, 61);
        padding: 2em 2em 2em 2em !important;
    }

    #info-cedula .card-body {
        background-color: rgb(88, 88, 88);
        padding: 2em 2em 2em 2em !important;
    }

    .titulo-descripcion {
        font-weight: initial !important;
    }

    #secciones-asignacion .card-footer {
        background-color: black;
    }

    #encabezados {
        margin-bottom: 1em;
    }

    #encabezados h1 {
        margin-bottom: 0;
        font-weight: bold;
    }

    #encabezados h4 {
        font-size: 1.5em;
        color: rgb(214, 214, 214);
    }

    .hr-titulo {
        height:0.5em;
        width: 6em;
        border:none;
        background-color:#ffffff;
    }

    .seccion-deshabilitada {
        pointer-events:none;
        cursor: not-allowed;
        opacity: 0.5;
    }
</style>
<style>
    #filtros .input-group-text {
        border-top-left-radius: 0.6vmin;
        border-bottom-left-radius: 0.6vmin;
        border: none;
    }

    #filtros .form-control {
        border: none !important;
    }

    .contenedor-tabla-asignacionesV2-SINOJ .btn-secondary {
        width: 2.5rem;
        background-color: #1f1f21;
        color: white;
        padding: 0.3em 0.3em 0.3em 0.3em;
        box-shadow: none;
    }

    .contenedor-tabla-asignacionesV2-SINOJ .form-control {
        background-color: white;
        color: rgb(63, 62, 62);
        border: 1px solid #656161 !important;
        height: 2.5em;
        width: 40vmin;
    }

    .contenedor-tabla-asignacionesV2-SINOJ td {
        /* background-color: rgb(238, 238, 238);
        vertical-align: middle; */
        cursor: pointer;
    }

    .contenedor-tabla-asignacionesV2-SINOJ tr.custom--success td {
        background-color: #5e5e5e; /*custom color here add !important if you don't want the hover color*/
        color: white;
    }

    .borderless td, .borderless th {
        border: none;
        border-bottom: 1px solid #d8d7d7 !important;
    }

    .contenedor-tabla-asignacionesV2-SINOJ table {
        table-layout: fixed;
        width: 100%;
        word-wrap:break-word;
    }

    .contenedor-tabla-asignacionesV2-SINOJ .btn-light {
        background-color: white;
        border: 1px solid #4F4949;
        color: #111111;
        font-size: 1em;
    }

    .contenedor-tabla-asignacionesV2-SINOJ .btn-ver-asignaciones-SINOJ:hover, .contenedor-tabla-asignacionesV2-SINOJ .btn-ver-asignaciones-SINOJ:focus {
        background-color: #1c1d1d;
        border: 1px solid #e1e2e2;
        color: white;
    }

    .contenedor-tabla-asignacionesV2-SINOJ .dropdown-toggle {
        width: 3.3rem;
        background-color: #1f1f21;
        color: white;
    }

    /*.contenedor-tabla-asignacionesV2-SINOJ .bs-checkbox .th-inner {
        pointer-events:none !important;
        cursor: not-allowed !important;
        opacity: 0.5 !important;
    }*/

    .contenedor-tabla-asignacionesV2-SINOJ .pagination > li > a {
        background-color: white;
        color: #121213;
    }

    .contenedor-tabla-asignacionesV2-SINOJ .pagination > .active > a {
        color: white;
        background-color:  #1f1f21;
        border: solid 1px #676666;
    }

    .contenedor-tabla-asignacionesV2-SINOJ > .active > a:hover {
        background-color:  #21211f;
        border: solid 1px #676666;
    }
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Cedulas/ManejoDeCedulas/AsignarNotificador/v2/CAsignacionDeCedulas.vue